import React from 'react'
import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react'
import 'font-awesome/css/font-awesome.css'
import './Map.css'

// 277-279 Broadway, Glebe NSW 2037
// Telephone: +61-2-8571 0800
const PESI_LOCATION = {
  center: {
    lat: -33.8842628,
    lng: 151.1931334,
  },
}

const AddressTooltip = ({ label, address }) => (
  <div className={'map-tooltip'}>
    <span className={'map-label'}>{label}</span>
    <div className={'map-tooltip-text'}>
      <div>{address.street}</div>
      <br />
      <div>
        <span>
          <i className={'fa fa-phone-square'} /> {address.phone}
        </span>
      </div>
    </div>
  </div>
)

AddressTooltip.propTypes = {
  label: PropTypes.string,
  address: PropTypes.string,
}

const GMap = ({
  width = 640,
  height = 480,
  zoom = 16,
  label = '',
  address = null,
  phone = null,
}) => {
  return (
    <div style={{ width, height }} className='pesi-map'>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.GATSBY_GMAP_API_KEY }}
        defaultCenter={PESI_LOCATION.center}
        defaultZoom={zoom}
      >
        <AddressTooltip
          lat={PESI_LOCATION.center.lat + 0.0001}
          lng={PESI_LOCATION.center.lng - 0.0001}
          label={label}
          address={{
            street: address,
            phone: phone,
          }}
        />
      </GoogleMapReact>
    </div>
  )
}

GMap.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  zoom: PropTypes.number,
  label: PropTypes.string,
  address: PropTypes.string,
  phone: PropTypes.string,
}

export default GMap



// WEBPACK FOOTER //
// ./src/components/Map/index.js